import React, { Component } from 'react';
import { firebaseApp } from '../../firebase'
import { RingLoader } from 'react-spinners'
import 'firebase/firestore'
import ajax from '../../ajax'
import ReactTable from 'react-table'
import matchSorter from 'match-sorter';


export default class Partners extends Component {

	constructor() {
		super()
		this.state = {
			vendors:[],
			emailSent: false
		}

		this.getVendors = this.getVendors.bind(this);
		this.removeVendor = this.removeVendor.bind(this);
		this.sendPasswordResetEmail = this.sendPasswordResetEmail.bind(this);
	}

    firestoreDb = firebaseApp.firestore();


    componentDidMount(){

    	this.getVendors();

    }

    getVendors(){
    	let { vendors } = this.state;

			fetch("https://us-central1-funily-deals.cloudfunctions.net/getVendors")
			.then(res => res.json())
			.then(function(json){
				if(json.status === "OK") {
					vendors = json.message;
					this.setState({vendors})
				}
			}.bind(this))
			.catch(err => console.log('ERROR',err));

    }

    removeVendor(vendor){
    	console.log('remove',vendor);

    	var confirm = window.confirm('Are you sure you want to delete ' + vendor.vendor + '?');

    	if(confirm){
    		console.log("deleting vendor");

				var url = "https://us-central1-funily-deals.cloudfunctions.net/removeVendor";
				var options = {
					method: 'POST',
					body: JSON.stringify(vendor)
				}
				fetch(url,options)
				.then(res => res.json())
				.then(function(json){
					console.log('jsonRes',json)
					this.getVendors();
				}.bind(this))
				.catch(err => console.log("ERROR",err))

    	} else {
    		console.log('cancelled deletion of vendor');
    	}

    }

    sendPasswordResetEmail(email){
    	firebaseApp.auth().sendPasswordResetEmail(email)
    	.then(function(){
    		this.setState({emailSent:!this.state.emailSent},() => {
    			setTimeout(function(){
    				this.setState({emailSent: !this.state.emailSent})
    			}.bind(this),1000)
    		})
    	}.bind(this))
    	.catch(err => console.log('error sendPasswordResetEmail',err));
    }


	render() {
		let { vendors } = this.state;
		let columns = [
			{
				Header: 'Partner',
				accessor: 'vendor',
				filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, {keys: ['vendor'] }),
	            filterAll: true
			},
			{
				Header: 'Manager',
				accessor: 'manager',
				filterable: false
			},
			{
				Header: 'Phone',
				accessor: 'phone',
				filterable: false
			},
			{
				Header: 'Email',
				accessor: 'email',
				filterable: false
			},
			{
				Header: 'Password',
				Cell: row => (
					<div>
					<button
					onClick={() => this.sendPasswordResetEmail(row.original.email)}
					>Send Password Reset Email</button>
					{
						this.state.emailSent ?
						<p>Email Sent</p>
						: null
					}
					</div>
					),
				filterable: false
			},
			{
				Header: 'Address',
				accessor: 'address',
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-danger' onClick={() =>this.removeVendor(row.original)}>Delete</button>),
				filterable: false
			}
		]

		if(vendors.length > 0){
			return (
				<div style={styles.container}>

					<ReactTable
						data={vendors}
						filterable
						// defaultFilterMethod={(filter, row) =>
		    //      		String(row[filter.vendor]) === filter.value}
						columns={columns}
						className="-striped -highlight"
					/>

				</div>

			)
		}


		return (
			<div style={{display:'flex',justifyContent:'center'}}>
					<RingLoader color='lightblue'
						size={200}
					 />
			</div>
		);
	}
}

const styles = {
	container:{
		marginTop: 100
	}
}



// WEBPACK FOOTER //
// ./src/components/admin/Partners.js